// extracted by mini-css-extract-plugin
export default {"modal":"yR-z","sharingIconsV2":"zR-z","notificationBox":"AR-z","checkMark":"BR-z","textFrame":"CR-z"};